import React, { useState } from 'react';
import { Typography } from '@mui/material';
import {
  CategoryBlock,
  CategoryDescription,
  CategoryHeader,
  CategorySwitch,
  ToggleVisibilityButton,
} from './styled-components';

interface CookieCategoryBlockProps {
  title: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onToggle?: (checked: boolean) => void;
}

export const CookieCategoryBlock = ({
  title,
  description,
  checked,
  disabled = false,
  onToggle,
}: CookieCategoryBlockProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle: (event: React.ChangeEvent<HTMLInputElement>) => void = event => {
    onToggle?.(event.target.checked);
  };

  const handleToggleExpanded: () => void = () => {
    setIsExpanded(prevState => !prevState);
  };

  return (
    <CategoryBlock>
      <CategoryHeader>
        <Typography variant="subtitle2">{title}</Typography>
        <CategorySwitch
          checked={checked}
          disabled={disabled}
          onChange={handleToggle}
          inputProps={{ 'aria-label': title }}
        />
      </CategoryHeader>
      <CategoryDescription variant="body1" isExpanded={isExpanded}>
        {description}
      </CategoryDescription>
      <ToggleVisibilityButton variant="text" color="primary" size="small" onClick={handleToggleExpanded}>
        {isExpanded ? 'Esconder' : 'Mostrar'}
      </ToggleVisibilityButton>
    </CategoryBlock>
  );
};
